<template>
  <div class="page-header-index-wide">
    <a-row :gutter="[8, 0]" class="playground" style="margin: -4px 0;">
      <a-col :sm="24" :md="12" :xl="8" class="playground" v-for="item in taskList">
        <chart-card :loading="loading" :needNum="false" title=" " class="task">
          <a-tooltip :title="item.tips" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div slot="content">
            <a-row :gutter="[8, 0]">
              <a-col :span="6" style="display: flex;justify-content: center;">
                <div class="task-icon">
                  <a-icon type="audit" />
                </div>
              </a-col>
              <a-col :span="18">
                <div class="task-content">
                  <div class="task-label">{{item.label}}</div>
                  <div class="task-num">{{item.num}}</div>
                </div>
              </a-col>
            </a-row>
          </div>
        </chart-card>
      </a-col>
    </a-row>
    <a-row :gutter="[8, 0]" class="playground">
      <a-col :sm="24" :md="24" :xl="24">
        <a-col :span="24">
          <chart-card :loading="loading" :bordered="false" :title="$t('业务类别占比')" :needNum="false" style="width: 100%;">
            <div slot="action">
              <a-radio-group default-value="1" @change="onChange1">
                <a-radio-button value="1">
                  {{ $t('近一周') }}
                </a-radio-button>
                <a-radio-button value="2">
                  {{ $t('近一月') }}
                </a-radio-button>
                <a-radio-button value="3">
                  {{ $t('近一年') }}
                </a-radio-button>
              </a-radio-group>
              <!-- <a-range-picker style="margin-left: 20px;">
                <a-icon slot="suffixIcon" type="calendar" />
              </a-range-picker> -->
            </div>
            <div slot="content" style="height: 300px;width: 100%;display: flex;justify-content: center;">
              <div id="option1" style="height: 100%;width:100%;"></div>
            </div>
          </chart-card>
        </a-col>
      </a-col>
    </a-row>
    <a-row :gutter="[8, 0]" class="playground">
      <a-col :sm="24" :md="24" :xl="24">
        <a-col :span="16">
          <chart-card :loading="loading" :bordered="false" :title="$t('工单统计')" :needNum="false" style="width: 100%;">
            <div slot="content" style="height: 300px;width: 100%;display: flex;justify-content: center;">
              <div id="option2" style="height: 100%;width:100%;"></div>
            </div>
          </chart-card>
        </a-col>
        <a-col :span="8">
          <chart-card :loading="loading" :bordered="false" :title="$t('工单来源')" :needNum="false" style="width: 100%;">
            <div slot="content" style="height: 300px;width: 100%;display: flex;justify-content: center;">
              <div id="option3" style="height: 100%;width:100%;"></div>
            </div>
          </chart-card>
        </a-col>
      </a-col>
    </a-row>
    <a-row :gutter="[8, 0]" class="playground">
      <a-col :sm="24" :md="24" :xl="24">
        <a-col :span="24">
          <chart-card :loading="loading" :bordered="false" :title="$t('部门工单处理情况')" :needNum="false" style="width: 100%;">
            <div slot="action">
              <a-radio-group default-value="1" @change="onChange2">
                <a-radio-button value="1">
                  {{ $t('近一周') }}
                </a-radio-button>
                <a-radio-button value="2">
                  {{ $t('近一月') }}
                </a-radio-button>
                <a-radio-button value="3">
                  {{ $t('近一年') }}
                </a-radio-button>
              </a-radio-group>
              <!-- <a-range-picker style="margin-left: 20px;">
                <a-icon slot="suffixIcon" type="calendar" />
              </a-range-picker> -->
            </div>
            <div slot="content" style="height: 300px;width: 100%;">
              <div style="margin: 10px 0 20px 0;">
                <div style="display: flex;justify-content: space-between;background-color: #f5f5f5;height: 50px;align-items: center;font-weight: bold;font-size: 20px;">
                  <div style="width: 20%;text-align: center;">{{ $t('工单总数') }}</div>
                  <div style="width: 20%;text-align: center;">{{ $t('已完成') }}</div>
                  <div style="width: 20%;text-align: center;">{{ $t('未完成') }}</div>
                  <div style="width: 20%;text-align: center;">{{ $t('超时未完成') }}</div>
                  <div style="width: 20%;text-align: center;">{{ $t('工单完成率') }}</div>
                </div>
                <div style="display: flex;justify-content: space-between;height: 50px;align-items: center;font-weight: bold;font-size: 20px;">
                  <div style="width: 20%;text-align: center;">{{tickets.ticketsNum}}</div>
                  <div style="width: 20%;text-align: center;">{{tickets.finishTicketsNum}}</div>
                  <div style="width: 20%;text-align: center;">{{tickets.unFinishTicketsNum}}</div>
                  <div style="width: 20%;text-align: center;">{{tickets.timeOutTicketsNum}}</div>
                  <div style="width: 20%;text-align: center;">{{tickets.ticketsFinishRatio}}</div>
                </div>
              </div>
              <!-- <div style="display: flex;justify-content: space-between;">
                <div style="width: 30%;border: 1px solid #eee;position: relative;">
                  <div style="height: 80px;display: flex;align-items: center;padding-left: 20px;">
                    <a-avatar style="backgroundColor:#3BA1FF;width: 40px;height: 40px;" icon="user" />
                    <span style="margin-left: 20px;">张三李四</span>
                  </div>
                  <div style="padding: 10px 0;">
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="width: 20%;text-align: center;">工单总数</div>
                      <div style="width: 20%;text-align: center;">已完成</div>
                      <div style="width: 20%;text-align: center;">未完成</div>
                      <div style="width: 20%;text-align: center;">超时未完成</div>
                      <div style="width: 20%;text-align: center;">工单完成率</div>
                    </div>
                    <div style="display: flex;justify-content: space-between;align-items: center;font-weight: bold;font-size: 16px;">
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">20%</div>
                    </div>
                  </div>
                  <div style="position: absolute;top: -15px;right: -15px;">
                    <a-avatar style="width: 50px;height: 50px;" :src="require('@/assets/jp1.png')" />
                  </div>
                </div>
                <div style="width: 30%;border: 1px solid #eee;position: relative;">
                  <div style="height: 80px;display: flex;align-items: center;padding-left: 20px;">
                    <a-avatar style="backgroundColor:#3BA1FF;width: 40px;height: 40px;" icon="user" />
                    <span style="margin-left: 20px;">张三李四</span>
                  </div>
                  <div style="padding: 10px 0;">
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="width: 20%;text-align: center;">工单总数</div>
                      <div style="width: 20%;text-align: center;">已完成</div>
                      <div style="width: 20%;text-align: center;">未完成</div>
                      <div style="width: 20%;text-align: center;">超时未完成</div>
                      <div style="width: 20%;text-align: center;">工单完成率</div>
                    </div>
                    <div style="display: flex;justify-content: space-between;align-items: center;font-weight: bold;font-size: 16px;">
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">20%</div>
                    </div>
                  </div>
                  <div style="position: absolute;top: -15px;right: -15px;">
                    <a-avatar style="width: 50px;height: 50px;" :src="require('@/assets/jp1.png')" />
                  </div>
                </div>
                <div style="width: 30%;border: 1px solid #eee;position: relative;">
                  <div style="height: 80px;display: flex;align-items: center;padding-left: 20px;">
                    <a-avatar style="backgroundColor:#3BA1FF;width: 40px;height: 40px;" icon="user" />
                    <span style="margin-left: 20px;">张三李四</span>
                  </div>
                  <div style="padding: 10px 0;">
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="width: 20%;text-align: center;">工单总数</div>
                      <div style="width: 20%;text-align: center;">已完成</div>
                      <div style="width: 20%;text-align: center;">未完成</div>
                      <div style="width: 20%;text-align: center;">超时未完成</div>
                      <div style="width: 20%;text-align: center;">工单完成率</div>
                    </div>
                    <div style="display: flex;justify-content: space-between;align-items: center;font-weight: bold;font-size: 16px;">
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">10</div>
                      <div style="width: 20%;text-align: center;">20%</div>
                    </div>
                  </div>
                  <div style="position: absolute;top: -15px;right: -15px;">
                    <a-avatar style="width: 50px;height: 50px;" :src="require('@/assets/jp1.png')" />
                  </div>
                </div>
              </div> -->
            </div>
          </chart-card>
        </a-col>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import ChartCard from '@/components/ChartCard'
  import echarts from 'echarts'
  import '@/assets/less/TableExpand.less'
  // import { mixinDevice } from '@/utils/mixin'
  // import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize from '@/mixins/TableDragResize'
  import {
    postAction,
    getAction
  } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  export default {
    components: {
      ChartCard
    },
    mixins: [TableDragResize],
    data() {
      return {
        loading: false,
        taskList: [{
          label: this.$t('待办事项'),
          num: 0,
          tips: this.$t('这是待办事项')
        }, {
          label: this.$t('已办事项'),
          num: 0,
          tips: this.$t('这是已办事项')
        }, {
          label: this.$t('事项完成率'),
          num: '0%',
          tips: this.$t('这是事项完成率')
        }],
        tickets:{
          ticketsNum: 0,
          finishTicketsNum: 0,
          unFinishTicketsNum: 0,
          timeOutTicketsNum: 0,
          ticketsFinishRatio: 0,
        },
        url: {
          list: "/jeecg-engineering/engineering/installationDetail/list",
          queryHomeIndex: "/jeecg-engineering/ticket/tickets/queryHomeIndex",
          queryHomeIndexTodo: "/jeecg-engineering/ticket/tickets/queryHomeIndexTodo",
          queryHomeIndexDone: "/jeecg-engineering/ticket/tickets/queryHomeIndexDone",
          queryHomeIndexTypeNum: "/jeecg-engineering/ticket/tickets/queryHomeIndexTypeNum",
          queryHomeIndexSourceTypeNum: "/jeecg-engineering/ticket/tickets/queryHomeIndexSourceTypeNum",
          queryHomeIndexDisposeNum: "/jeecg-engineering/ticket/tickets/queryHomeIndexDisposeNum",
        },
      }
    },
    mounted() {
      this.getHomeIndexTodo();
      this.getHomeIndex();
      this.getHomeIndexTypeNum(1);
      this.getHomeIndexSourceTypeNum();
      this.getHomeIndexDisposeNum(1);
    },
    methods: {
      onChange1(e){
        this.getHomeIndexTypeNum(e.target.value);
      },
      onChange2(e){
        this.getHomeIndexDisposeNum(e.target.value);
      },
      // 获取待办数量
      getHomeIndexTodo(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.queryHomeIndexTodo,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.taskList[0].num = data.toDo;
            this.getHomeIndexDone().then(val=>{
              if(val.done&&data.toDo){
                this.taskList[2].num = ((val.done / (val.done+data.toDo))*100).toFixed(2) +'%';
              }else{
                this.taskList[2].num = '0%';
              }
            })
          }
        })
      },
      // 获取已办数量
      getHomeIndexDone(queryType,beginTime,endTime){
        return new Promise((resolve,reject)=>{
          var params = {
            queryType,
            beginTime,
            endTime,
          };
          postAction(this.url.queryHomeIndexDone,params).then(res=>{
            if(res.success){
              var data = res.result;
              this.taskList[1].num = data.done;
              resolve(data);
            }
          })
        })
      },
      // 获取工单统计数据
      getHomeIndex(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.queryHomeIndex,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption2(data);
          }
        })
      },
      // 获取工单类别占比
      getHomeIndexTypeNum(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.queryHomeIndexTypeNum,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption1(data[0].num,data[1].num,data[2].num);
          }
        })
      },
      // 获取工单来源
      getHomeIndexSourceTypeNum(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.queryHomeIndexSourceTypeNum,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption3(data[0].num,data[1].num);
          }
        })
      },
      // 获取工单情况
      getHomeIndexDisposeNum(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.queryHomeIndexDisposeNum,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.tickets = {
              ticketsNum: data.ticketsNum,
              finishTicketsNum: data.finishTicketsNum,
              unFinishTicketsNum: data.unFinishTicketsNum,
              timeOutTicketsNum: data.timeOutTicketsNum,
              ticketsFinishRatio: (data.ticketsFinishRatio*100).toFixed(2)+'%',
            }
          }
        })
      },
      setOption1(a,b,c) {
        var chartDom1 = document.getElementById('option1');
        var myChart = echarts.init(chartDom1);
        var option = {
          title: {
            text: this.$t('工单总数'),
            subtext: a+b+c,
            left: 'center',
            top: '42%',
            textStyle: {
              fontSize: 20,
              color: '#000',
              align: 'center'
            },
            subtextStyle: {
              fontSize: 16,
              color: '#000',
              align: 'center'
            }
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            type: 'scroll',
            orient: 'vertical',
            right: '20%',
            top: 20,
            bottom: 20,
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          series: [{
            name: this.$t('工单'),
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: true,
            // hoverAnimation: false, // 禁用鼠标悬浮动画
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 3,
            },
            label: {
              show: true,
              position: 'left',
              formatter: '{b}:{d}%',
              fontSize: 16,
            },
            emphasis: {
              label: {
                show: true,
              }
            },
            labelLine: {
              show: true
            },
            data: [{
                value: a,
                name: this.$t('换表'),
                itemStyle: {
                  normal: {
                    color: '#3BA1FF'
                  },
                  emphasis: {
                    color: '#3BA1FF'
                  }
                }
              },
              {
                value: b,
                name: this.$t('工程报装'),
                itemStyle: {
                  normal: {
                    color: '#69D389'
                  },
                  emphasis: {
                    color: '#69D389'
                  }
                }
              },
              {
                value: c,
                name: this.$t('故障报修'),
                itemStyle: {
                  normal: {
                    color: '#6633CC'
                  },
                  emphasis: {
                    color: '#6633CC'
                  }
                }
              },
            ]
          }]
        };
        option && myChart.setOption(option);
      },
      setOption2(params) {
        var xdata = [];
        var ticketsNum = [];
        var ticketsFinish = [];
        var timeliness = [];
        params.map(item=>{
          xdata.push(item.dateTime);
          ticketsNum.push(item.ticketsNum);
          ticketsFinish.push(item.ticketsFinish);
          timeliness.push(item.timeliness);
        });
        var chartDom = document.getElementById('option2');
        var myChart = echarts.init(chartDom);
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          // toolbox: {
          //   feature: {
          //     dataView: {
          //       show: true,
          //       readOnly: false
          //     },
          //     magicType: {
          //       show: true,
          //       type: ['line', 'bar']
          //     },
          //     restore: {
          //       show: true
          //     },
          //     saveAsImage: {
          //       show: true
          //     }
          //   }
          // },
          legend: {
            bottom: '3%',
            // data: ['派单数', 'Precipitation', 'Temperature']
          },
          xAxis: [{
            type: 'category',
            data: xdata,
            axisPointer: {
              type: 'shadow'
            }
          }],
          yAxis: [{
              type: 'value',
              // name: 'Precipitation',
              // min: 0,
              // max: 10000,
              // interval: 2000,
              axisLabel: {
                formatter: '{value}'
              }
            },
            {
              type: 'value',
              // name: 'Temperature',
              // min: 0,
              // max: 100,
              // interval: 20,
              axisLabel: {
                formatter: '{value} %'
              }
            }
          ],
          // color: ['#3BA1FF','#69D389','#FF9898'],
          series: [{
              name: this.$t('派单数'),
              type: 'bar',
              tooltip: {
                valueFormatter: function(value) {
                  return value + ' ml';
                }
              },
              data: ticketsNum,
              itemStyle: {
                normal: {
                  color:'#3BA1FF',
                  barBorderRadius:[5, 5 , 0, 0]
                }

              }
            },
            {
              name: this.$t('完成数'),
              type: 'bar',
              tooltip: {
                valueFormatter: function(value) {
                  return value + ' ml';
                }
              },
              data: ticketsFinish,
              itemStyle: {
                normal: {
                  color:'#69D389',
                  barBorderRadius:[5, 5 , 0, 0]
                }
              }
            },
            {
              name: this.$t('及时率(%)'),
              type: 'line',
              yAxisIndex: 1,
              tooltip: {
                valueFormatter: function(value) {
                  return value + ' °C';
                }
              },
              data: timeliness,
              itemStyle: {
                color:'#FF9898'
              }
            }
          ]
        };
        option && myChart.setOption(option);
      },
      setOption3(a,b) {
        var chartDom = document.getElementById('option3');
        var myChart = echarts.init(chartDom);
        var option = {
          title: {
            text: this.$t('工单来源'),
            // subtext: '100',
            left: 'center',
            top: '45%',
            textStyle: {
              fontSize: 20,
              color: '#000',
              align: 'center'
            },
            subtextStyle: {
              fontSize: 16,
              color: '#000',
              align: 'center'
            }
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            // top: '3%',
            bottom: '0%',
            // bottom: 'center',
          },
          grid: {
            top: '-3%',
            left: '3%',
            right: '3%',
            // bottom: '10%',
            containLabel: true
          },
          series: [{
            name: this.$t('工单来源'),
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: true,
            // hoverAnimation: false, // 禁用鼠标悬浮动画
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 3,
            },
            label: {
              show: true,
              position: 'left',
              formatter: '{b}:{d}%',
              fontSize: 16,
            },
            emphasis: {
              label: {
                show: true,
              }
            },
            labelLine: {
              show: true
            },
            data: [{
                value: a,
                name: 'PC',
                itemStyle: {
                  normal: {
                    color: '#FBD444'
                  },
                  emphasis: {
                    color: '#FBD444'
                  }
                }
              },
              {
                value: b,
                name: this.$t('微信公众号'),
                itemStyle: {
                  normal: {
                    color: '#2FC25A'
                  },
                  emphasis: {
                    color: '#2FC25A'
                  }
                }
              },
            ]
          }]
        };
        option && myChart.setOption(option);
      },
    }
  }
</script>

<style scoped lang="less">
  .task {
    /deep/.ant-card-body {
      height: 150px !important;
      padding: 20px !important;
    }

    .task-icon {
      width: 66px;
      height: 66px;
      border-radius: 50%;
      background-color: rgb(0, 162, 255);
      display: flex;
      align-items: center;
      justify-content: center;

      .anticon-audit {
        color: #fff;
        font-size: 30px;
      }
    }

    .task-content {
      margin-left: 30px;

      .task-label {
        font-size: 14px;
        color: #999;
      }

      .task-num {
        font-size: 30px;
        font-weight: bold;
        color: #000;
      }
    }
  }

  /deep/.ant-card-body {
    padding: 20px !important;
  }

  /deep/.ant-table-thead>tr>th {
    background-color: #fafafa;
  }

  /deep/.ant-table-thead>tr>th:not(:first-child):before,
  /deep/.ant-table-thead>tr>th:not(:last-child):after {
    background-color: #e8e8e8;
  }
</style>